var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"authentication"},[_c('router-view'),_c('c-snackbar'),_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }